module.exports = __webpack_public_path__ + "static/beauty-appointment-section-15a3801deb6090a772659fc3df879b5b.png";